import { Component, inject, Input, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import Article from 'src/smoothr-web-app-core/models/Article';
import { ShortInfoModalComponent } from '../short-info-modal/short-info-modal.component';
import { ModalController } from '@ionic/angular';

@Component({
	selector: 'app-tag',
	templateUrl: './tag.component.html',
	styleUrls: ['tag.component.scss'],
	standalone: false,
})
export class TagComponent implements OnInit {
	@Input() article: Article;
	@Input() iconSize: { width: number; height: number } = { width: 20, height: 20 };
	environment = environment;

	private modalCtrl = inject(ModalController);
	constructor() {}

	ngOnInit() {}

	showInfo(event: Event) {
		event.stopPropagation();
		ShortInfoModalComponent.show(this.modalCtrl, this.article);
	}
}
